import React, { useState } from 'react';
import Layout from '../LayoutPage/Layout/Layout';
import { parseArchivo } from '../../../utils/horarios/parseHorariosExcel';
import { generarCombinaciones } from '../../../utils/horarios/calcularHorarios';
import { exportar } from '../../../utils/horarios/exportHorariosExcel';
import './CalcularHorarios.css';

const CalcularHorarios = () => {
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [filasCargadas, setFilasCargadas] = useState([]);
  const [erroresCarga, setErroresCarga] = useState([]);
  const [cantidadAulas, setCantidadAulas] = useState('3');
  const [horaInicioDia, setHoraInicioDia] = useState('07:00');
  const [horaFinDia, setHoraFinDia] = useState('19:00');
  const [numeroCombinaciones, setNumeroCombinaciones] = useState('3');
  const [calculando, setCalculando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  const handleArchivoChange = async (e) => {
    const archivo = e.target.files[0];
    setMensaje(null);
    setFilasCargadas([]);
    setErroresCarga([]);
    setNombreArchivo('');

    if (!archivo) return;

    try {
      const { filas, errores } = await parseArchivo(archivo);
      setNombreArchivo(archivo.name);
      setFilasCargadas(filas);
      setErroresCarga(errores);
    } catch (error) {
      console.error('Error al leer el Excel:', error);
      setMensaje({ tipo: 'danger', texto: 'No se pudo leer el archivo. Verifica que sea un .xlsx válido.' });
    }
  };

  const datosValidos =
    filasCargadas.length > 0 &&
    erroresCarga.length === 0 &&
    Number(cantidadAulas) >= 1 &&
    Number(numeroCombinaciones) >= 1 &&
    Number(numeroCombinaciones) <= 5 &&
    horaInicioDia < horaFinDia;

  const handleCalcular = () => {
    setCalculando(true);
    setMensaje(null);

    try {
      const propuestas = generarCombinaciones({
        filas: filasCargadas,
        cantidadAulas: Number(cantidadAulas),
        horaInicioDia,
        horaFinDia,
        numeroCombinaciones: Number(numeroCombinaciones),
      });

      const { totalSinAsignar } = exportar(propuestas, `horarios_calculados_${Date.now()}.xlsx`);

      if (totalSinAsignar > 0) {
        setMensaje({
          tipo: 'warning',
          texto: `Se descargó el Excel, pero ${totalSinAsignar} sesión(es) no se pudieron asignar sin choques (ver hoja "Resumen").`,
        });
      } else {
        setMensaje({ tipo: 'success', texto: 'Se descargó el Excel con todas las sesiones asignadas correctamente.' });
      }
    } catch (error) {
      console.error('Error al calcular horarios:', error);
      setMensaje({ tipo: 'danger', texto: 'Ocurrió un error al calcular los horarios. Revisa la consola para más detalle.' });
    } finally {
      setCalculando(false);
    }
  };

  return (
    <Layout mostrarAside={false}>
      <div className="container mt-1">
       
        <p>
          Carga el Excel con las materias (SEMESTRE, ID, FECHA INICIO, FECHA FIN, Duración, Duración semana,
          Duración máxima ya llenas). El sistema asignará aula, día y horario automáticamente.
        </p>

        <div className="mb-3">
          <label className="form-label">Archivo Excel (.xlsx)</label>
          <input type="file" accept=".xlsx,.xls" className="form-control" onChange={handleArchivoChange} />
          {nombreArchivo && (
            <div className="form-text">
              {nombreArchivo}: {filasCargadas.length} fila(s) cargada(s).
            </div>
          )}
          {erroresCarga.length > 0 && (
            <div className="alert alert-danger mt-2">
              <strong>El archivo tiene datos incompletos:</strong>
              <ul className="mb-0">
                {erroresCarga.slice(0, 10).map((error) => (
                  <li key={error}>{error}</li>
                ))}
              </ul>
              {erroresCarga.length > 10 && <div>...y {erroresCarga.length - 10} más.</div>}
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-md-3 mb-3">
            <label className="form-label">Cantidad de aulas disponibles</label>
            <input
              type="number"
              min="1"
              className="form-control"
              value={cantidadAulas}
              onChange={(e) => setCantidadAulas(e.target.value)}
            />
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Hora inicio del día</label>
            <input
              type="time"
              className="form-control"
              value={horaInicioDia}
              onChange={(e) => setHoraInicioDia(e.target.value)}
            />
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Hora fin del día</label>
            <input
              type="time"
              className="form-control"
              value={horaFinDia}
              onChange={(e) => setHoraFinDia(e.target.value)}
            />
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Número de combinaciones (1-5)</label>
            <input
              type="number"
              min="1"
              max="5"
              className="form-control"
              value={numeroCombinaciones}
              onChange={(e) => setNumeroCombinaciones(e.target.value)}
            />
          </div>
        </div>

        <button className="btn btn-primary" disabled={!datosValidos || calculando} onClick={handleCalcular}>
          {calculando ? 'Calculando...' : 'Calcular horarios'}
        </button>

        {mensaje && <div className={`alert alert-${mensaje.tipo} mt-3`}>{mensaje.texto}</div>}
      </div>
    </Layout>
  );
};

export default CalcularHorarios;
